export default "__VITE_ASSET__9r7RpYPj__"